import '@babel/polyfill'
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import App from './App'

import router from './router'

import store from './store/store'

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'animate.css/animate.min.css'

import '@fortawesome/fontawesome-free/css/all.css'

import VueLoading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

import i18n from './language/i18n'

import Vuelidate from 'vuelidate'

import LoadScript from 'vue-plugin-load-script'

import './assets/css/style.scss'

import VueYoutube from 'vue-youtube'
import VueMathjax from 'vue-mathjax'

import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'

import VueSanitize from 'vue-sanitize'

import Vuetify from 'vuetify'

import '@mdi/font/scss/materialdesignicons.scss'

import CKEditor from '@ckeditor/ckeditor5-vue'

Vue.use(Vuetify)

Vue.use(VueSanitize)

Vue.use(VueMathjax)
Vue.use(VueYoutube)

Vue.use(CKEditor)

Vue.use(BootstrapVue)
Vue.use(VueLoading, {
  color: '#3B94F1',
  isFullPage: true,
  loader: 'dots',
  backgroundColor: '#ffffff',
  width: 128,
  height: 128,
  opacity: 0.5,
  zIndex: 9999
})

Vue.use(LoadScript)

Vue.use(Vuelidate)
Sentry.setTag('projeto', 'projeto_b2b')
Sentry.init({
  Vue,
  dsn: process.env.VUE_APP_DSN_SENTRY,
  environment: process.env.VUE_APP_ENV,
  integrations: [
    new Integrations.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: ['localhost', /^\//]
    })
  ],
  tracesSampleRate: 0.001,
  logErrors: true
})

Vue.config.productionTip = false

window.eventBus = new Vue({})
/* eslint-disable no-new */
new Vue({
  router,
  i18n,
  store,
  vuetify: new Vuetify(),
  render: h => h(App)
}).$mount('#app')
